import { Anchor, Compass, Gem } from "lucide-react";
import { usePageMeta } from "@/lib/seo";

export default function About() {
  usePageMeta("Tentang Kami", "Kenali NAWADAH by NDH Official — supplier & distributor tunggal Tali PP LUMBA LUMBA & KUDA EMAS, Katrol LUMBA LUMBA, dan Timbangan di Indonesia.");
  return (
    <div className="bg-navy-dark text-white">
      <section className="relative py-28 noise-overlay" data-testid="about-hero">
        <img src="https://images.unsplash.com/photo-1781628443176-702855c02a34" alt="Tali di kapal" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-[#040F1D]/80" />
        <div className="absolute inset-0 bg-maritime-grid" />
        <div className="absolute inset-0" style={{ background: "radial-gradient(ellipse at 85% 15%, rgba(201,162,39,0.16) 0%, transparent 50%)" }} />
        <div className="absolute inset-0 vignette-overlay" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6">
          <p className="text-xs font-bold uppercase tracking-[0.3em] text-gold mb-4">Tentang Kami</p>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-none max-w-3xl">
            NAWADAH <span className="text-gold italic">by</span> NDH Official
          </h1>
        </div>
      </section>

      <section className="relative py-24 bg-rope-pattern noise-overlay" data-testid="about-story">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 grid grid-cols-1 lg:grid-cols-2 gap-14 items-start">
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.3em] text-gold mb-3">Latar Belakang</p>
            <h2 className="font-display text-2xl sm:text-3xl tracking-tight mb-6">Melayani Kebutuhan Maritim &amp; Industri Indonesia</h2>
            <div className="space-y-4 text-slate-300 text-sm sm:text-base leading-relaxed">
              <p>
                NAWADAH adalah unit bisnis dari <strong className="text-white">NDH Official</strong> yang berfokus pada
                penjualan Tali Tambang, Katrol, dan Timbangan (Manual dan Digital). Kami berdiri dengan satu komitmen:
                menghadirkan produk berkualitas sempurna dengan pelayanan yang mengutamakan kepuasan pelanggan.
              </p>
              <p>
                Sebagai <strong className="text-gold">supplier &amp; distributor tunggal</strong> Tali PP merek <strong className="text-white">LUMBA LUMBA</strong> dan{" "}
                <strong className="text-white">KUDA EMAS</strong>, Katrol <strong className="text-white">LUMBA LUMBA</strong>, serta Timbangan
                Manual dan Digital, kami memastikan setiap produk yang Anda terima adalah produk asli dengan standar kualitas terbaik.
              </p>
              <p>
                Dengan jangkauan layanan di <strong className="text-white">seluruh Indonesia</strong>,
                kami melayani kebutuhan toko, nelayan, kontraktor proyek, hingga industri dengan stok yang selalu siap.
              </p>
            </div>
          </div>
          <div className="space-y-6">
            {[
              { icon: Compass, title: "Visi", desc: "Menjadi distributor peralatan tali, katrol, dan timbangan paling terpercaya di Indonesia dengan standar kualitas sempurna." },
              { icon: Anchor, title: "Misi", desc: "Menyediakan produk asli berkualitas, harga bersaing, stok selalu siap, serta pelayanan cepat dan ramah bagi setiap pelanggan." },
              { icon: Gem, title: "Nilai Kami", desc: "Kualitas Sempurna dan Kepuasan Pelanggan bukan sekadar slogan — keduanya adalah prioritas dalam setiap transaksi." },
            ].map((v) => (
              <div key={v.title} data-testid={`about-${v.title.toLowerCase().replace(/\s/g, "-")}`} className="card-maritime-surface rounded-md p-8 hover:border-gold/50 transition-colors">
                <v.icon className="h-8 w-8 text-gold mb-4" />
                <h3 className="font-display text-xl mb-2">{v.title}</h3>
                <p className="text-sm text-slate-400 leading-relaxed">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
